import { useState, useEffect } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { FaPen } from 'react-icons/fa'
import { useSelector, useDispatch } from 'react-redux'

import { updateEmploiAction } from '../actions/emploiActions'
import Loading from '../components/Loading'

function UpdateEmploi({ emploi }) {
	const [values, setValues] = useState({
		titre: emploi.titre,
		description: emploi.description,
		adresse: emploi.adresse,
		salaire: emploi.salaire,
		nombre_heure: emploi.nombre_heure,
	})
	const [etat, setEtat] = useState(emploi.etat)
	const [show, setShow] = useState(false)

	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const dispatch = useDispatch()

	const { success, loading, message } = useSelector((state) => state.emploi)

	const onChange = (e) => {
		setValues({ ...values, [e.target.name]: e.target.value })
	}

	const onClick = () => {
		const updatedEmploi = {
			titre: values.titre,
			description: values.description,
			etat,
			adresse: values.adresse,
			salaire: values.salaire,
			nombre_heure: values.nombre_heure,
		}
		dispatch(updateEmploiAction(emploi._id, updatedEmploi))
	}

	useEffect(() => {
		if (success && message) {
			handleClose()
		}
	}, [dispatch, success, message])

	return (
		<>
			<Button className='rounded-circle m-0 ms-1' onClick={handleShow}>
				<FaPen />
			</Button>{' '}
			<Modal show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Mettre à jour</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group className='mb-3'>
						<Form.Control
							type='text'
							placeholder='Titre'
							name='titre'
							value={values.titre}
							onChange={onChange}
						/>
					</Form.Group>
					<Form.Group className='mb-3'>
						<Form.Control
							as='textarea'
							placeholder='Description'
							rows={10}
							name='description'
							value={values.description}
							onChange={onChange}
						/>
					</Form.Group>
					<Form.Group className='mb-3'>
						<Form.Select onChange={(e) => setEtat(e.target.value)} value={etat}>
							<option value='disponible'>Disponible</option>
							<option value='non disponible'>Non disponible</option>
						</Form.Select>
					</Form.Group>
					<Form.Group className='mb-3'>
						<Form.Control
							type='text'
							placeholder='Adresse'
							name='adresse'
							value={values.adresse}
							onChange={onChange}
						/>
					</Form.Group>
					<Form.Group className='mb-3'>
						<Form.Control
							type='text'
							placeholder='Salaire'
							name='salaire'
							value={values.salaire}
							onChange={onChange}
						/>
					</Form.Group>
					<Form.Group className='mb-3'>
						<Form.Control
							type='text'
							placeholder="Nombre d'heures"
							name='nombre_heure'
							value={values.nombre_heure}
							onChange={onChange}
						/>
					</Form.Group>
				</Modal.Body>
				<Modal.Footer>
					<Button variant='danger' onClick={handleClose}>
						Annuler
					</Button>
					<Button type='submit' onClick={onClick} disabled={loading && true}>
						Enregistrer {loading && <Loading sm='sm' />}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default UpdateEmploi
